import type { DailyItemLocale, DailyItemLocaleResponse } from './types';

export function mapDailyItemLocale(data: DailyItemLocaleResponse): DailyItemLocale {
  return {
    localeCode: data.locale_code,
    body: data.body,
    quote: data.quote,
    reference: data.reference,
  };
}
